<template>
  <div class="flex flex-col gap-y-5 overflow-hidden">
    <ul class="flex items-center gap-x-5">
      <c_cell title="关键字">
        <template #default>
          <el-input
            v-model="state.params.keywords"
            placeholder="请输入关键字"
          ></el-input>
        </template>
      </c_cell>
      <c_cell title="乙方单位">
        <template #default>
          <el-input
            v-model="state.params.keywords"
            placeholder="请输入关键字"
          ></el-input>
        </template>
      </c_cell>
      <c_cell title="所属分会">
        <template #default>
          <el-input
            v-model="state.params.keywords"
            placeholder="请输入关键字"
          ></el-input>
        </template>
      </c_cell>
      <el-button type="primary" @click="onLoad">搜索</el-button>
      <div class="flex justify-end flex-1">
        <el-button
          type="warning"
          link
          icon="Edit"
          v-if="!state.edit"
          @click="state.edit = true"
        >
          调整采购项
        </el-button>
        <el-button
          type="success"
          link
          icon="Select"
          v-else
          @click="state.edit = false"
        >
          完成调整
        </el-button>
        <el-button
          type="primary"
          link
          icon="Plus"
          @click="state.showAdd = true"
          v-if="state.edit"
        >
          添加虚拟采购项
          <el-tooltip
            placement="top"
            effect="dark"
            content="虚拟采购项只在此页面做数据记录，不参与后续的相关计算"
          >
            <el-icon class="cursor-pointer"><QuestionFilled /></el-icon>
          </el-tooltip>
        </el-button>
        <el-button type="info" link icon="Plus" disabled v-else>
          添加虚拟采购项
          <el-tooltip
            placement="top"
            effect="dark"
            content="请点击'调整采购项'按钮开启编辑模式"
          >
            <el-icon class="cursor-pointer"><QuestionFilled /></el-icon>
          </el-tooltip>
        </el-button>

        <el-button type="primary" link icon="Plus">生成报账单</el-button>
        <el-button type="warning" link icon="Tickets">账单记录</el-button>
      </div>
    </ul>
    <el-table
      :data="state.list_data"
      v-loading="!Array.isArray(state.list_data)"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      max-height="65vh"
    >
      <el-table-column>
        <template #header>
          <div class="c-table-col-header" label1="所属分会" label2="乙方单位" />
        </template>
        <template #default="{ row }">
          <c_tabgroup>
            <template #top>
              <strong>{{ row.hcmc }}</strong>
            </template>
            <template #bottom>
              <text>{{ row.jfmc }}</text>
              <text class="text-gray-400 text-xs">{{ row.jfbh }}</text>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div class="c-table-col-header" label1="采购名称" label2="供应商" />
        </template>
        <template #default="{ row }">
          <c_tabgroup>
            <template #top>
              <strong>{{ row.mc }}</strong>
            </template>
            <template #bottom>
              <text>{{ row.gysmc }}</text>
              <text class="text-gray-400 text-xs">{{ row.gysbh }}</text>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div class="c-table-col-header" label1="采购项" label2="规格" />
        </template>
        <template #default="{ row }">
          <c_tabgroup>
            <template #top>
              <text>[{{ row.lx }}]</text>
              <strong>{{ row.mc }}</strong>
            </template>
            <template #bottom>
              <text>{{ row.gg }}</text>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column label="采购价合计">
        <template #default="{ row }">
          <c_tabgroup>
            <template #top>
              <text>{{ row.hj }}</text>
            </template>
            <template #bottom>
              <text>{{ row.dj + "*" + row.sl + row.dw }}</text>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="bz" :formatter="$tab_TextFormat" />
      <el-table-column
        label="报账单价"
        prop="sksm"
        :formatter="$tab_TextFormat"
      >
        <template #default="{ row }">
          <text>{{ row.dj }}</text>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div class="flex items-center gap-x-1">
            <div class="c-table-col-header" label1="数量" label2="天数"></div>
            <el-tooltip
              placement="top"
              effect="dark"
              content="天数=租赁设备的使用天数"
            >
              <el-icon class="cursor-pointer"><QuestionFilled /></el-icon>
            </el-tooltip>
          </div>
        </template>
        <template #default="{ row }">
          <text>{{ row.sl + "/" + (row.ts || "-") }}</text>
        </template>
      </el-table-column>
      <el-table-column prop="je" :formatter="$tab_MoneyFormat">
        <template #header>
          <div class="flex items-center gap-x-1">
            <li>报账金额</li>
            <el-tooltip
              placement="top"
              effect="dark"
              content="报账金额=报账单价*数量*天数"
            >
              <el-icon class="cursor-pointer mb-1"><QuestionFilled /></el-icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      v-model="state.showAdd"
      title="添加虚拟采购项"
      class="c-el-dialog"
      :before-close="
        () => {
          state.showAdd = false;
        }
      "
      width="100%"
      style="height: 100%; max-height: 100%"
    >
      <c_add
        :meeting_id="props.meeting_id"
        :id="state.selectId"
        :search="props.search"
        @close="
          (refresh) => {
            state.showAdd = false;
            if (refresh) onLoad();
          }
        "
      />
    </el-dialog>
  </div>
  <el-dialog
    v-model="state.showEdit"
    title="费用明细项调整"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showEdit = false;
      }
    "
    width="90%"
    append-to=".dialog-dom"
    modal
    :modal-penetrable="false"
    :draggable="false"
  >
    <div class="flex items-center absolute top-5 left-28 gap-x-1">
      <text>报账金额合计:</text>
      <c_money :value="150000" bold :prefix="false" />
    </div>
    <c_edit
      :id="state.selectId"
      :search="props.search"
      @close="
        (refresh) => {
          state.showEdit = false;
          if (refresh) onLoad();
        }
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";

import c_add from "./Add.vue";
import c_edit from "./Edit.vue";

export default {
  components: { c_add, c_edit },
  props: {
    meeting_id: Number,
    id: Number,
  },
  setup(props) {
    const state = reactive({
      params: {},
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      state.list_data = [];

      for (let index = 0; index < 30; index++) {
        state.list_data.push({
          id: index + 1,
          hcmc: "主会场",
          jfmc: "北京华宇国际大酒店",
          jfbh: "1001",
          mc: "会议桌",
          gysmc: "北京华宇国际大酒店",
          gysbh: "1001",
          lx: "桌椅",
          mc: "会议桌",
          gg: "长1.5米，宽0.8米",
          hj: "1000",
          dj: "1000",
          sl: "10",
          dw: "张",
          bz: "无",
          sksm: "1000",
          ts: "10",
          je: 1000,
        });
      }
    };
    return { state, props };
  },
};
</script>

<style lang="less" scoped></style>
